// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"d2531d75","50":"282753c6","180":"35a26b79","237":"4f60078e","354":"ca39c0dd","453":"03346f77","467":"ee2a564e","505":"d20ee4a7","535":"34d3bda2","552":"22df359c","595":"2d8fb299","718":"009b83f2","783":"b4f1fc01"}[chunkId] + ".chunk.js";
};